<div class="flex justify-content-center mr-1">
  <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>
  <button
    pButton
    type="button"
    (click)="menu.toggle($event)"
    [icon]="(selectedLang$ | async)?.icon || ''"
  ></button>
</div>

